module.exports = __webpack_public_path__ + "img/free.4b645a6e.png";